// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"0de23b40","917":"45145919"}[chunkId] + ".chunk.js";
};